import React from 'react';
import ReactDOM from 'react-dom/client';
// Bootstrap d'abord, puis nos surcharges : sinon le CSS de nos composants
// (importé via App) serait injecté avant Bootstrap, qui reprendrait le dessus.
import 'bootstrap/dist/css/bootstrap.min.css';
import './custom.scss';
import './index.css';
import './style/theme.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Service worker (PWA) : uniquement en production.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/sw.js`).catch(() => {});
  });
}
